import { render, staticRenderFns } from "./pbl1.vue?vue&type=template&id=69443449&scoped=true&"
import script from "./pbl1.vue?vue&type=script&lang=js&"
export * from "./pbl1.vue?vue&type=script&lang=js&"
import style0 from "./pbl1.vue?vue&type=style&index=0&id=69443449&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69443449",
  null
  
)

export default component.exports